import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useItensChecklistServicoEmpreendimentoFilters
 */

type State = {
    idChecklistServicoEmpreendimento: number;
    idsChecklistServico: number[];
    idsBlocos: number[];
    idsUnidades: number[];
    idsItemServicoEmpreendimento: number[];
};

type Action = {
    setIdChecklistServicoEmpreendimento: (idChecklistServicoEmpreendimento: number) => void,
    setIdsChecklistServico: (idsChecklistServico: number[]) => void,
    setIdsBlocos: (idsBlocos: number[]) => void,
    setIdsUnidades: (idsUnidades: number[]) => void,
    setIdsItemServicoEmpreendimento: (idsItemServicoEmpreendimento: number[]) => void,
};

export const useItensChecklistServicoEmpreendimentoFilters = create<State & Action>((set) => ({
    idChecklistServicoEmpreendimento: 0,
    idsChecklistServico: [],
    idsBlocos: [],
    idsUnidades: [],
    idsItemServicoEmpreendimento: [],
    setIdChecklistServicoEmpreendimento: (idChecklistServicoEmpreendimento) => set({ idChecklistServicoEmpreendimento }),
    setIdsChecklistServico: (idsChecklistServico) => set({ idsChecklistServico }),
    setIdsBlocos: (idsBlocos) => set({ idsBlocos }),
    setIdsUnidades: (idsUnidades) => set({ idsUnidades }),
    setIdsItemServicoEmpreendimento: (idsItemServicoEmpreendimento) => set({ idsItemServicoEmpreendimento }),

}));